import { useContext } from 'react'
import { useStore } from 'state/store'
import Incentives from 'views/Incentives'
import Loading from 'components/Loading'
import { RemoteConfigContext } from 'lib/remoteConfig/RemoteConfigContext'
import ComingSoon from 'views/ComingSoon'

export const IncentivesContainer = () => {
  const organizationId = useStore(state => state.organization.id)
  const workspaceId = useStore(state => state.workspace.id)
  const timezone = useStore(state => state.workspace.timezone)
  const { getBoolean, configLoaded } = useContext(RemoteConfigContext)
  const incentivesEnabled = getBoolean('hera_incentive_plans')

  if (!configLoaded || !workspaceId || !organizationId || !timezone) {
    return <Loading />
  }

  if (incentivesEnabled) {
    return (
      <Incentives
        organizationId={organizationId}
        workspaceId={workspaceId}
        timezone={timezone}
      />
    )
  }

  return (
    <ComingSoon
      title="pmportal.incentives.title"
      description="pmportal.incentives.description"
    />
  )
}
